module.exports = __webpack_public_path__ + "static/img/icon-flashsale.ea94601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/icon-flashsale.png
// module id = h3wO
// module chunks = 134